import { Component, Input, ViewChild, EventEmitter, Output } from "@angular/core";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";

export class PhoneActionEvent {
    public phone: string;

    constructor(phone: string) {
        this.phone = phone;
    }
}

@Component({
    selector: 'datatable-phone-cell',
    templateUrl: './datatablePhoneCell.component.html',
    styleUrls: ['./datatablePhoneCell.component.css'],
    standalone: false
})
export class DatatablePhoneCellComponent {
    @Input() public phone: string;

    @ViewChild(NgbDropdown) private dropdown: NgbDropdown;

    @Output() public onSendSMS: EventEmitter<PhoneActionEvent> = new EventEmitter<PhoneActionEvent>();

    public onRightClick(event: Event): boolean {
        this.dropdown.open();

        return false;
    }

    public onSendSMSClick(event: Event) {
        event.stopPropagation();
        this.dropdown.close();

        this.onSendSMS.emit(new PhoneActionEvent(this.phone));

        return false;
    }
}